module.exports = __webpack_public_path__ + "img/icon_intellig_loc_scenic_select.7d1488e0.svg";